import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar";

const SKU_LINKS = [

    {
    title: "SKU Master",
    subtitle: "Review, filter, and bulk update SKU master data.",
    path: "/sku-management/sku-master",
    accent: "#0f766e",
  },
    {
    title: "Unit Economics",
    subtitle: "Maintain cost and economics details by SKU and marketplace.",
    path: "/sku-management/unit-economics",
    accent: "#334155",
  },
  
  {
    title: "Listing Master",
    subtitle: "Manage listing and channel-level SKU metadata.",
    path: "/sku-management/listing-master",
    accent: "#be123c",
  },
  {
    title: "NPD Master",
    subtitle: "Track and manage new product development records.",
    path: "/sku-management/npd",
    accent: "#c2410c",
  },
  {
    title: "SKU Creation",
    subtitle: "Create new SKU rows in single or bulk mode.",
    path: "/sku-management/sku-creation",
    accent: "#1d4ed8",
  },

    {
    title: "I-SKU Explorer",
    subtitle: "Fetch complete NPD to SKU flow by parent SKU or I-SKU in one view.",
    path: "/sku-management/isku-explorer",
    accent: "#0f766e",
  },

  {
    title: "Category Master",
    subtitle: "Manage category values used across SKU workflows.",
    path: "/sku-management/category",
    accent: "#9333ea",
  },
  {
    title: "Dropdown Admin",
    subtitle: "Manage reusable dropdown options for SKU and NPD forms.",
    path: "/sku-management/dropdown-admin",
    accent: "#0f766e",
  },


  {
    title: "Catalogue Master",
    subtitle: "Manage catalogue links, packaging iterations, and approval status.",
    path: "/sku-management/catalouge-master",
    accent: "#7c3aed",
  },

];

export default function SkuManagementLanding() {
  const navigate = useNavigate();

  return (
    <div style={styles.page}>
      <Navbar />
      <div style={styles.container}>
        <div style={styles.headerRow}>
          <div>
            <h1 style={styles.title}>SKU Management</h1>
            <p style={styles.subtitle}>Open any SKU module from one place.</p>
          </div>
          <button type="button" style={styles.backButton} onClick={() => navigate("/")}>
            Back To Dashboard
          </button>
        </div>

        <div style={styles.grid}>
          {SKU_LINKS.map((item) => (
            <button
              key={item.path}
              type="button"
              onClick={() => navigate(item.path)}
              style={{ ...styles.card, borderColor: `${item.accent}33` }}
            >
              <div style={{ ...styles.badge, background: `${item.accent}20`, color: item.accent }}>
                SKU
              </div>
              <div style={styles.cardTitle}>{item.title}</div>
              <div style={styles.cardSubtitle}>{item.subtitle}</div>
              <div style={{ ...styles.cardArrow, color: item.accent }}>Open</div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%)",
  },
  container: {
    padding: "20px",
  },
  headerRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    marginBottom: 16,
    flexWrap: "wrap",
  },
  title: {
    margin: 0,
    fontSize: 28,
    color: "#0f172a",
  },
  subtitle: {
    margin: "6px 0 0",
    color: "#475569",
    fontSize: 14,
  },
  backButton: {
    height: 38,
    border: "1px solid #cbd5e1",
    borderRadius: 10,
    background: "#ffffff",
    color: "#1e293b",
    padding: "0 14px",
    fontWeight: 600,
    cursor: "pointer",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: 12,
  },
  card: {
    border: "1px solid #e2e8f0",
    borderRadius: 14,
    background: "#ffffff",
    textAlign: "left",
    padding: 14,
    cursor: "pointer",
    boxShadow: "0 8px 24px rgba(15, 23, 42, 0.08)",
    transition: "transform 0.15s ease",
  },
  badge: {
    width: "fit-content",
    borderRadius: 999,
    fontSize: 11,
    fontWeight: 700,
    padding: "4px 8px",
    marginBottom: 10,
  },
  cardTitle: {
    fontSize: 16,
    fontWeight: 700,
    color: "#0f172a",
    marginBottom: 8,
  },
  cardSubtitle: {
    fontSize: 13,
    color: "#475569",
    minHeight: 38,
    marginBottom: 12,
  },
  cardArrow: {
    fontSize: 13,
    fontWeight: 700,
  },
};
